import React, { Component } from "react";

class StaffAssignments extends Component {
  render() {
    return <h1 className="text-right">{this.props.data}</h1>;
  }
}

export default StaffAssignments;
